// File: client/src/components/rules/expressionEditor/constants.js

// Operator definitions with display labels and JavaScript equivalents
export const OPERATORS = {
    equals: { label: 'Equals', code: '===' },
    notEquals: { label: 'Not Equals', code: '!==' },
    contains: { label: 'Contains', code: '.includes' },
    startsWith: { label: 'Starts With', code: '.startsWith' },
    endsWith: { label: 'Ends With', code: '.endsWith' },
    matchesRegex: { label: 'Matches RegEx', code: '.match' },
    greaterThan: { label: 'Greater Than', code: '>' },
    lessThan: { label: 'Less Than', code: '<' },
    greaterThanEquals: { label: 'Greater Than or Equal', code: '>=' },
    lessThanEquals: { label: 'Less Than or Equal', code: '<=' },
};

// Logic operators for combining conditions
export const LOGIC_OPERATORS = {
    and: { label: 'AND', code: '&&' },
    or: { label: 'OR', code: '||' },
};
